import React, { useContext, useState } from 'react';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { svgSprite, Tooltip } from '../../../../../../hybrid/wrappers';
import UserContext, { UserProfileContext } from '../../../../../../common/utils/getContext';
import QrCode from '../../../../../qrCode/qrCode';
import { t } from '../../../../../../common/components/T';
import { useWidgetTranslates } from '../../../../../../common/utils/utils';
import SocialShare from '../../../../../../hybrid/library/SocialShare/SocialShare';
import css from './CopyType.module.scss';
import classnames from 'classnames';
import { generateCompStylers } from '../../../../../../common/utils/styles';

const CopyType = ({ compStyle, copy, message, val }) => {
    const { stylers, classes } = generateCompStylers(compStyle);

    const { adminPage } = useContext(UserProfileContext);
    const { setAlertData } = useContext(UserContext);
    const [qrModal, setQrModal] = useState(false);
    const { qr, positionDropdown, hint, hideShare } = copy;
    const transl = useWidgetTranslates('form');

    return (
        <>
            {qr ? (
                <>
                    <div
                        onClick={() => {
                            setQrModal(true);
                        }}
                        style={stylers.copy}
                        className={classnames(css.formControlIconWrap, css.copyInputIconWrap, classes.copy)}
                    >
                        {svgSprite(adminPage ? 'qr' : 'qr-gt', {
                            width: '19px',
                            height: '20px',
                            fill: 'var(--greyExtraDarkColor)',
                            className: css.copyTypeIcon
                        })}
                    </div>
                    {qrModal && <QrCode title={qr} closeHandler={() => setQrModal(false)} val={val} />}
                </>
            ) : null}
            {!hideShare && (
                <div className={classnames(css.copyInputIconWrap)}>
                    <SocialShare
                        compCss={{ iconWrap: classnames(css.formControlIconWrap, classes.copy), icon: css.copyTypeIcon }}
                        title={qr}
                        val={val}
                        positionDropdown={positionDropdown}
                    />
                </div>
            )}
            <CopyToClipboard
                text={val}
                onCopy={() =>
                    setAlertData({
                        type: 'success',
                        cont:
                            message?.copy ||
                            message?.success ||
                            t('FormCopy-CopyReferalLink-success', 'Скопировано в буфер обмена', 'widget', transl, 'form')
                    })
                }
            >
                <div>
                    <Tooltip
                        compStyle={{
                            tooltipWrap: {
                                className: classnames(css.copyInputIconWrap, classes?.copyInputIconWrap)
                            },
                            inner: {
                                ...stylers.copy,
                                className: classnames(css.formControlIconWrap, classes.copy)
                            }
                        }}
                        text={hint}
                        disableOnMobile={true}
                    >
                        {svgSprite(adminPage ? 'file-copy' : 'file-copy-gt-system', {
                            width: '20px',
                            height: '20px',
                            fill: 'var(--greyExtraDarkColor)',
                            className: css.copyTypeIcon
                        })}
                    </Tooltip>
                </div>
            </CopyToClipboard>
        </>
    );
};
export default CopyType;
